import React, { useState, useRef, useEffect } from 'react';

import { Input, CloseButton, useT } from '@repo/common';
import ActivityBanner from './ActivityBanner';

const EMPTY = { title: '', date: '', description: '' };

const DESC_MAX = 1000;

const MobileActivityFullPage = ({ initialData, onClose, onSave }) => {
  const t = useT();
  const [form, setForm] = useState(() => ({
    ...EMPTY,
    ...(initialData || {}),
  }));
  const titleRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => titleRef.current?.focus(), 0);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const setField = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <div className='fixed inset-0 z-[60] flex flex-col bg-grayscale-gray00'>
      {/* Header */}
      <div className='relative shrink-0 h-[54px] px-4 py-3 flex items-center justify-between border-b border-grayscale-gray02'>
        <CloseButton onClick={onClose} />
        <span className='flex-1 truncate px-2 text-center typo-b16Strong text-text-primary'>
          {t('Activity (Learning & Participation)', '활동 (학습 및 참여)')}
        </span>
        <div className='size-6' />
      </div>

      {/* Body */}
      <div className='flex-1 overflow-y-auto px-4 pt-[30px] pb-[160px] flex flex-col gap-4'>
        {/* Activity title */}
        <Input
          ref={titleRef}
          label={t('Activity title', '활동명')}
          placeholder={t(
            'e.g. YONSEI Korean Language Institute',
            '예: 연세대학교 한국어학당',
          )}
          value={form.title}
          onChange={(e) => setField('title', e.target.value)}
          hideCount
        />

        {/* Date */}
        <Input
          label={t('Date', '날짜')}
          placeholder={t('e.g. Oct 2023', '예: 2023년 10월')}
          value={form.date}
          onChange={(e) => setField('date', e.target.value)}
          hideCount
        />

        {/* Description */}
        <div className='flex flex-col gap-2 pb-5'>
          <span className='typo-b14Strong text-text-primary'>
            {t('Description', '설명')}
          </span>
          <Input
            as='textarea'
            label=''
            placeholder={t(
              `Briefly describe what you did, your role, and the outcome.
e.g. Achieved TOPIK Level 5 through intensive Korean language training, with professional reading and writing proficiency`,
              '수행한 일과 역할, 결과를 간단히 설명해 주세요.\n예: 집중적인 한국어 교육을 통해 TOPIK 5급을 취득하고 전문적인 읽기 및 쓰기 능력을 갖췄습니다.',
            )}
            value={form.description}
            onChange={(e) => setField('description', e.target.value)}
            maxLength={DESC_MAX}
            textareaRows={6}
          />
        </div>

        <ActivityBanner isMobileFullPage={true} />
      </div>

      {/* Footer — Add */}
      <div className='shrink-0 px-4 pt-3 pb-[calc(env(safe-area-inset-bottom)+12px)] border-t border-grayscale-gray02'>
        <button
          type='button'
          onClick={() => onSave(form)}
          className='w-full h-[52px] rounded-[12px] bg-[#1DC37B] text-[#F9F7F4] text-[16px] font-medium transition-colors active:bg-[#009E4F]'
        >
          {t('Add', '추가')}
        </button>
      </div>
    </div>
  );
};

export default MobileActivityFullPage;
